import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import {ReactComponent as dragHandleSvg} from "../../../assets/dragHandle.svg";
import Icon from "../../../components/Icon/Icon";
import "./SortableItem.scss"

const SortableItem = ({id, children}) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({id: id});

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
    };
    return (
        <div ref={setNodeRef} style={style} className="sortable-item">
            <div className="drag" {...attributes} {...listeners}>
                <Icon svg={dragHandleSvg} className="drag" />
            </div>
            <div className="content">
                {children}
            </div>
        </div>
    )
}

export default SortableItem;